import React, {memo, useCallback, useEffect, useMemo, useState} from "react"
import {useHistory} from "react-router-dom"
import {useKeyboard} from "../../../../hooks/keyboard"
import {useMessage} from "../../../../hooks/message"
import {useLocalization} from "../../../../hooks/localization"
import {useRPC} from "../../../../hooks/rpc"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {SettingInputComponent} from "../../../../components/Settings/SettingInputComponent"
import {isValidNumber} from "../../../../utils/validation"

const BACK_URL = "/settings/intercom/blocked-list"
export const SIPAddBlockNumber = memo(function SIPAddBlockNumber() {
    const {t} = useLocalization()
    const {success, failure} = useMessage()
    const [setActiveNumpadInput, renderNumpadKeyboard, currentNumpadInput] = useKeyboard("numpad", true)
    const [rpc] = useRPC()
    const history = useHistory()
    const [name, setName] = useState("")
    const [blockNumber, setBlockNumber] = useState("")

    const onClickAddNumber = useCallback(() => {
        if (!isValidNumber(blockNumber) || blockNumber.length === 0) {
            failure(t("pls_enter_a_valid_sip_no"))
            return
        }
        if (name.length === 0) {
            failure(t("pls_enter_a_valid_name"))
            return
        }
        rpc.updateCallBlockList({number: blockNumber, name: name, blocked_count: 0, sip_number: ''})
            .then(() => {
                success(t("number_blocked_successfully"))
                history.push(BACK_URL)
            })
            .catch(failure)
    }, [t, failure, success, rpc, blockNumber, history, name])

    const buttons = useMemo(
        () => [
            {
                text: t("save"),
                className: "green",
                onClick: onClickAddNumber
            }
        ],
        [t, onClickAddNumber]
    )

    const onBlur = useCallback(() => {
        setActiveNumpadInput(null)
    }, [setActiveNumpadInput])

    useEffect(() => {
        setActiveNumpadInput(null)
        // eslint-disable-next-line
    }, [])

    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer
                className="service-edit"
                buttons={buttons}
                backUrl={BACK_URL}
                currentNumpadInput={currentNumpadInput}
            >
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingInputComponent
                            placeholder={t("enter_a_flat_name")}
                            label={t("name")}
                            value={name}
                            setValue={setName}
                            setActiveInput={setActiveNumpadInput}
                            onBlur={onBlur}
                        />
                        <SettingInputComponent
                            placeholder={t("pls_enter_block_number")}
                            label={t("enter_block_number")}
                            value={blockNumber}
                            setValue={setBlockNumber}
                            setActiveInput={setActiveNumpadInput}
                            onBlur={onBlur}
                        />
                    </div>
                    <div className="content-wrapper"></div>
                </div>
            </SettingsPageContainer>
            {renderNumpadKeyboard()}
        </PasswordContainer>
    )
})
